import { LinkType } from '../dragon/DragonPage.const';

export const ART_LINKS: LinkType[] = [
	{
		link: '/art/art-creation',
		title: 'Art Creation',
	},
	{
		link: '/art/neo-traditional',
		title: 'Neo Traditional',
	},
	{
		link: '/art/japanese-traditional',
		title: 'Japanese Traditional',
	},
];
